/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Definitions_External_Data_LabelInputs */

const es_tyc_definitions_external_data_label = /** @type {(inputs: Tyc_Definitions_External_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos Externos`)
};

const en_tyc_definitions_external_data_label = /** @type {(inputs: Tyc_Definitions_External_Data_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External Data`)
};

/**
* | output |
* | --- |
* | "External Data" |
*
* @param {Tyc_Definitions_External_Data_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_definitions_external_data_label = /** @type {((inputs?: Tyc_Definitions_External_Data_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Definitions_External_Data_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_definitions_external_data_label(inputs)
	return en_tyc_definitions_external_data_label(inputs)
});
export { tyc_definitions_external_data_label as "tyc.definitions.external_data_label" }